import MigrationBanner from './MigrationBanner';
import DocumentBanner from './DocumentBanner';

/**
 * Registro de tipos de banners
 * Para agregar un nuevo tipo:
 * 1. Crear el componente en esta carpeta
 * 2. Importarlo aquí
 * 3. Agregarlo al registro con su clave única
 * 
 * Ejemplo futuro:
 * import NewsBanner from './NewsBanner';
 * 'news': NewsBanner
 */
export const BANNER_REGISTRY = {
  migration: MigrationBanner,
  document: DocumentBanner,
  // Preparado para futuros tipos:
  // news: NewsBanner,
  // event: EventBanner,
  // benefits: BenefitsBanner,
  // birthday: BirthdayBanner,
  // survey: SurveyBanner,
  // maintenance: MaintenanceBanner
};

/**
 * Valida si existe un tipo de banner registrado
 */
export const isBannerTypeValid = (type) => {
  return type in BANNER_REGISTRY;
};

/**
 * Obtiene el componente para un tipo de banner
 */
export const getBannerComponent = (type) => {
  return BANNER_REGISTRY[type] || null;
};
